import styled from '@emotion/styled';
import { colorPalette } from '@sharefiledev/antd-config';
import { colorMap } from '../../../common/componentUtils';

const resizeHhandleMargin = '-4px';

export const StyledResizable = styled.div<{
	isAnnotation: boolean;
	isTextAnnotation: boolean;
	showErrorOnResizable: boolean;
	componentColor: string;
	isSameComponent: boolean;
}>`
	height: 100%;
	width: 100%;
	position: absolute;
	left: 0;
	top: 0;

	border-radius: 5px;

	&:hover {
		border: ${props =>
			props.isSameComponent
				? getBorderStyle(
						props.isAnnotation,
						props.showErrorOnResizable,
						props.componentColor
				  )
				: 0};
		margin: ${props => (props.isSameComponent ? '-1px' : 0)};
		border-radius: ${props => (props.isTextAnnotation ? '2px' : 0)};
	}

	.resizable-handle {
		font-size: 0.1px;
		display: none;
		-ms-touch-action: none;
		touch-action: none;
		border-radius: 35%;
		background: white;
		width: 4px;
		height: 4px;
		position: absolute;
		margin: 0;
		&-annotation {
			width: 2.17px;
			height: 2.17px;
			border: 2px solid ${colorPalette.neutral13};
		}
	}

	.resizable-handle-w,
	.resizable-handle-e {
		top: 48%;
	}

	.resizable-handle-n {
		margin-top: ${resizeHhandleMargin};
		margin-left: ${resizeHhandleMargin};
		left: 50%;
		top: 0;
		cursor: n-resize;
		&.resizable-handle-annotation {
			margin-top: ${resizeHhandleMargin};
			margin-left: ${resizeHhandleMargin};
		}
	}
	.resizable-handle-s {
		margin-bottom: ${resizeHhandleMargin};
		margin-left: ${resizeHhandleMargin};
		left: 50%;
		bottom: 0;
		cursor: s-resize;
		&.resizable-handle-annotation {
			margin-top: ${resizeHhandleMargin};
			margin-left: ${resizeHhandleMargin};
		}
	}
	.resizable-handle-w {
		top: 50%;
		margin-top: ${resizeHhandleMargin};
		margin-left: ${resizeHhandleMargin};
		left: 0;
		cursor: w-resize;
		&.resizable-handle-annotation {
			margin-top: ${resizeHhandleMargin};
			margin-left: ${resizeHhandleMargin};
		}
	}
	.resizable-handle-e {
		margin-top: ${resizeHhandleMargin};
		margin-right: ${resizeHhandleMargin};
		top: 50%;
		right: 0;
		cursor: e-resize;
		&.resizable-handle-annotation {
			margin-top: ${resizeHhandleMargin};
			margin-right: ${resizeHhandleMargin};
		}
	}
	.resizable-handle-sw {
		margin-bottom: ${resizeHhandleMargin};
		margin-left: ${resizeHhandleMargin};
		bottom: 0;
		left: 0;
		cursor: sw-resize;
		&.resizable-handle-annotation {
			margin-bottom: ${resizeHhandleMargin};
			margin-left: ${resizeHhandleMargin};
		}
	}
	.resizable-handle-se {
		margin-bottom: ${resizeHhandleMargin};
		margin-right: ${resizeHhandleMargin};
		bottom: 0;
		right: 0;
		cursor: se-resize;
		&.resizable-handle-annotation {
			margin-bottom: ${resizeHhandleMargin};
			margin-right: ${resizeHhandleMargin};
		}
	}
	.resizable-handle-ne {
		margin-top: ${resizeHhandleMargin};
		margin-right: ${resizeHhandleMargin};
		top: 0;
		right: 0;
		cursor: ne-resize;
		&.resizable-handle-annotation {
			margin-top: ${resizeHhandleMargin};
			margin-right: ${resizeHhandleMargin};
		}
	}
	.resizable-handle-nw {
		margin-top: ${resizeHhandleMargin};
		margin-left: ${resizeHhandleMargin};
		top: 0;
		left: 0;
		cursor: nw-resize;
		&.resizable-handle-annotation {
			margin-top: ${resizeHhandleMargin};
			margin-left: ${resizeHhandleMargin};
		}
	}
	&:hover .resizable-handle {
		display: block;
	}
`;

const getBackgroundColor = props => {
	if (props.isTextAnnotation) {
		return 'transparent';
	} else {
		return colorMap[props.componentColor]?.backgroundColor;
	}
};
const getBorderColor = props => {
	if (props.isError) {
		return '#ab0000';
	} else if (props.isTextAnnotation) {
		return '#171717';
	} else if (props.isAnnotation || props.hideBorder) {
		return 'transparent';
	} else {
		return colorMap[props.componentColor]?.borderColor;
	}
};

export const StyledPageComponent = styled.div<{
	isAnnotation: boolean;
	isTextAnnotation: boolean;
	componentColor: string;
	isError: boolean;
	hideBorder: boolean;
}>`
	box-sizing: border-box;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: row;
	padding: 0;
	gap: 8px;
	border: ${props => (props.isAnnotation ? 0 : '1px solid')};
	border-radius: 4px;
	cursor: move;
	height: 100%;
	width: 100%;
	margin: ${props => (props.isAnnotation ? 0 : '0')};
	background-color: ${props => getBackgroundColor(props)};
	border-color: ${props => getBorderColor(props)};
	&:hover {
		border-width: 2px;
		border-style: solid;
	}
`;

//define border logic based on condition
function getBorderStyle(isAnnotation, showErrorOnResizable, componentColor): string {
	if (isAnnotation) {
		return `2px solid ${colorPalette.neutral13}`;
	} else if (showErrorOnResizable) {
		return `1px solid ${colorPalette.red6}`;
	}
	return `1px solid ${componentColor}`;
}
